import ajax from '../utils/ajax';

export interface ValidationResult {
  fieldId: string,
  message: string,
  isValid: boolean,
}

export interface FormValidationResult {
  isValid: boolean,
  validationResults: ValidationResult[],
}

async function validateForm(formData: {}) {
  const result = await ajax.post('/api/validation/validateForm', {
    formData,
  });

  return result as FormValidationResult;
}

export default {
  validateForm,
};
